/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: n8fP5hwrb7Lg

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import FeaturesProductHeader from "../../FeaturesProductHeader"; // plasmic-import: nCl4kJqd_uCB/component
import Logo from "../../Logo"; // plasmic-import: 2Sac1UHK8925/component
import FeaturesCard from "../../FeaturesCard"; // plasmic-import: eBFTaYn0ldI-/component
import ListItem from "../../ListItem"; // plasmic-import: vpKD71-ztgZQ/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import sty from "./PlasmicFeaturesMyCme.module.css"; // plasmic-import: n8fP5hwrb7Lg/css

import Icon5Icon from "./icons/PlasmicIcon__Icon5"; // plasmic-import: z8Bk5fXmTx-P/icon

createPlasmicElementProxy;

export type PlasmicFeaturesMyCme__VariantMembers = {};
export type PlasmicFeaturesMyCme__VariantsArgs = {};
type VariantPropType = keyof PlasmicFeaturesMyCme__VariantsArgs;
export const PlasmicFeaturesMyCme__VariantProps = new Array<VariantPropType>();

export type PlasmicFeaturesMyCme__ArgsType = {};
type ArgPropType = keyof PlasmicFeaturesMyCme__ArgsType;
export const PlasmicFeaturesMyCme__ArgProps = new Array<ArgPropType>();

export type PlasmicFeaturesMyCme__OverridesType = {
  myCme?: Flex__<"section">;
  desktop?: Flex__<"div">;
  row?: Flex__<"div">;
  key2?: Flex__<"div">;
  header?: Flex__<"header">;
  list?: Flex__<"div">;
  row2?: Flex__<"div">;
  all?: Flex__<"div">;
  title?: Flex__<"h2">;
  sections?: Flex__<"div">;
  col2?: Flex__<"div">;
  list2?: Flex__<"div">;
  col3?: Flex__<"div">;
  section2?: Flex__<"div">;
  list4?: Flex__<"div">;
  freeBox?: Flex__<"div">;
  tablet?: Flex__<"div">;
  row6?: Flex__<"div">;
  key4?: Flex__<"div">;
  header4?: Flex__<"header">;
  list11?: Flex__<"div">;
  row7?: Flex__<"div">;
  row8?: Flex__<"div">;
  all3?: Flex__<"div">;
  title3?: Flex__<"h2">;
  sections4?: Flex__<"div">;
  col4?: Flex__<"div">;
  list3?: Flex__<"div">;
  col11?: Flex__<"div">;
  section7?: Flex__<"div">;
  list5?: Flex__<"div">;
  mobile?: Flex__<"div">;
  header3?: Flex__<"div">;
  key3?: Flex__<"div">;
  header2?: Flex__<"header">;
  list6?: Flex__<"div">;
  all2?: Flex__<"div">;
  title2?: Flex__<"h2">;
  sections5?: Flex__<"div">;
  col8?: Flex__<"div">;
  list12?: Flex__<"div">;
  col12?: Flex__<"div">;
  section8?: Flex__<"div">;
  list13?: Flex__<"div">;
};

export interface DefaultFeaturesMyCmeProps {
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicFeaturesMyCme__RenderFunc(props: {
  variants: PlasmicFeaturesMyCme__VariantsArgs;
  args: PlasmicFeaturesMyCme__ArgsType;
  overrides: PlasmicFeaturesMyCme__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const globalVariants = _useGlobalVariants();

  const styleTokensClassNames = _useStyleTokens();

  return (
    <section
      data-plasmic-name={"myCme"}
      data-plasmic-override={overrides.myCme}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_bvRZj1oZhhFBeMnkX2LkQu",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.myCme
      )}
      id={"MyCME"}
    >
      {(hasVariant(globalVariants, "mobile", "mobile") ? false : true) ? (
        <PlasmicImg__
          alt={""}
          className={classNames(sty.img__h5Aa5)}
          displayHeight={"527px"}
          displayMaxHeight={"none"}
          displayMaxWidth={"none"}
          displayMinHeight={"0"}
          displayMinWidth={"0"}
          displayWidth={"1770px"}
          loader={"plasmic"}
          loading={"lazy"}
          src={{
            src: "https://site-assets.plasmic.app/67f04ddfb024c31590f097503108861e.svg",
            fullWidth: 1770,
            fullHeight: 527,
            aspectRatio: 3.358634
          }}
        />
      ) : null}
      {(
        hasVariant(globalVariants, "mobile", "mobile")
          ? false
          : hasVariant(globalVariants, "mobile", "tabletPortrait")
            ? false
            : true
      ) ? (
        <div
          data-plasmic-name={"desktop"}
          data-plasmic-override={overrides.desktop}
          className={classNames("all", sty.desktop)}
        >
          <div
            data-plasmic-name={"row"}
            data-plasmic-override={overrides.row}
            className={classNames("all", sty.row)}
          >
            <FeaturesProductHeader
              className={classNames(
                "__wab_instance",
                sty.featuresProductHeader__cPgn7
              )}
              description={
                hasVariant(globalVariants, "mobile", "mobile")
                  ? "MyEvaluations streamlines medical training with efficient scheduling, compliance tracking, and custom evaluations. The secure platform saves time and resources, enabling comprehensive reports for improved outcomes."
                  : "MyCME streamlines CME fulfillment, automates PARS reports, and maintains financial records. Faculty benefits from a unified system for tracking evaluations and reporting MOC to ACCME-supported boards."
              }
              subtitle={
                hasVariant(globalVariants, "mobile", "mobile")
                  ? "Product"
                  : "Product"
              }
            >
              <Logo
                className={classNames("__wab_instance", sty.logo__doSz7)}
                product={"myCme"}
              />
            </FeaturesProductHeader>
          </div>
          <div
            data-plasmic-name={"key2"}
            data-plasmic-override={overrides.key2}
            className={classNames("all", sty.key2)}
          >
            <header
              data-plasmic-name={"header"}
              data-plasmic-override={overrides.header}
              className={classNames("all", sty.header)}
            >
              <h2
                className={classNames(
                  "all",
                  "h2",
                  "h2__bvRZj",
                  "__wab_text",
                  sty.h2__otjU9
                )}
              >
                {"Key Features"}
              </h2>
            </header>
            <div
              data-plasmic-name={"list"}
              data-plasmic-override={overrides.list}
              className={classNames("all", sty.list)}
            >
              <div
                data-plasmic-name={"row2"}
                data-plasmic-override={overrides.row2}
                className={classNames("all", sty.row2)}
              >
                <FeaturesCard
                  className={classNames(
                    "__wab_instance",
                    sty.featuresCard__tcaiM
                  )}
                  desciption={
                    "Incorporate CME management seamlessly. Craft live and enduring activities, streamline scheduling, optimize resource allocation, and centralize recurring events. "
                  }
                  title={"Live & Durable Event Scheduling"}
                >
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img__pKzWr)}
                    displayHeight={"239px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={{
                      src: "https://img.plasmic.app/img-optimizer/v1/img/ffae84bb12c6d9e0bddc6d44c05fcfd4.png",
                      fullWidth: 374,
                      fullHeight: 239
                    }}
                  />
                </FeaturesCard>
                <FeaturesCard
                  className={classNames(
                    "__wab_instance",
                    sty.featuresCard__rc1RL
                  )}
                  desciption={
                    "Issue, earn and store CME certificates effortlessly. Design certificate templates for future use. Track external CME credits for comprehensive education management."
                  }
                  title={"CME Certificate Management"}
                >
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img__zyQw)}
                    displayHeight={"239px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={{
                      src: "https://img.plasmic.app/img-optimizer/v1/img/8fabeaac8b8d5113cbb6018ddc2d60ce.png",
                      fullWidth: 374,
                      fullHeight: 239
                    }}
                  />
                </FeaturesCard>
                <FeaturesCard
                  className={classNames(
                    "__wab_instance",
                    sty.featuresCard__lzu59
                  )}
                  desciption={
                    "Automate CME reporting with direct ACCME PARS integration. Streamline event data linking for timely submissions, maintaining high training standards, reducing administrative burden, and ensuring accreditation compliance."
                  }
                  title={"ACCME Connectivity to PARS"}
                >
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img__tzgMf)}
                    displayHeight={"239px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={{
                      src: "https://img.plasmic.app/img-optimizer/v1/img/60719a6ed83c2cc70dbca19adf82e2ae.png",
                      fullWidth: 374,
                      fullHeight: 239
                    }}
                  />
                </FeaturesCard>
              </div>
            </div>
          </div>
          <div
            data-plasmic-name={"all"}
            data-plasmic-override={overrides.all}
            className={classNames("all", sty.all)}
          >
            <h2
              data-plasmic-name={"title"}
              data-plasmic-override={overrides.title}
              className={classNames(
                "all",
                "h2",
                "h2__bvRZj",
                "__wab_text",
                sty.title
              )}
            >
              {"Full Feature List"}
            </h2>
            <div
              data-plasmic-name={"sections"}
              data-plasmic-override={overrides.sections}
              className={classNames("all", sty.sections)}
            >
              <div
                data-plasmic-name={"col2"}
                data-plasmic-override={overrides.col2}
                className={classNames("all", sty.col2)}
              >
                <div
                  data-plasmic-name={"list2"}
                  data-plasmic-override={overrides.list2}
                  className={classNames("all", sty.list2)}
                >
                  {(_par => (!_par ? [] : Array.isArray(_par) ? _par : [_par]))(
                    (() => {
                      try {
                        return [
                          {
                            text: "Event Evaluations"
                          },
                          {
                            text: "Live Event Scheduling"
                          },
                          {
                            text: "Durable Event Library"
                          },
                          {
                            text: "External Registration"
                          },
                          {
                            text: "Fee Processing"
                          },
                          {
                            text: "Membership Management"
                          },
                          {
                            text: "Flier Production"
                          }
                        ];
                      } catch (e) {
                        if (
                          e instanceof TypeError ||
                          e?.plasmicType === "PlasmicUndefinedDataError"
                        ) {
                          return [];
                        }
                        throw e;
                      }
                    })()
                  ).map((__plasmic_item_0, __plasmic_idx_0) => {
                    const currentItem = __plasmic_item_0;
                    const currentIndex = __plasmic_idx_0;
                    return (
                      <ListItem
                        className={classNames(
                          "__wab_instance",
                          sty.listItem___1KcAb
                        )}
                        key={currentIndex}
                        text={(() => {
                          try {
                            return currentItem.text;
                          } catch (e) {
                            if (
                              e instanceof TypeError ||
                              e?.plasmicType === "PlasmicUndefinedDataError"
                            ) {
                              return undefined;
                            }
                            throw e;
                          }
                        })()}
                      >
                        <Icon5Icon
                          className={classNames("all", sty.svg__pCSx)}
                          role={"img"}
                        />
                      </ListItem>
                    );
                  })}
                </div>
              </div>
              <div
                data-plasmic-name={"col3"}
                data-plasmic-override={overrides.col3}
                className={classNames("all", sty.col3)}
              >
                <div
                  data-plasmic-name={"section2"}
                  data-plasmic-override={overrides.section2}
                  className={classNames("all", sty.section2)}
                >
                  <div
                    data-plasmic-name={"list4"}
                    data-plasmic-override={overrides.list4}
                    className={classNames("all", sty.list4)}
                  >
                    {(_par =>
                      !_par ? [] : Array.isArray(_par) ? _par : [_par])(
                      (() => {
                        try {
                          return [
                            {
                              text: "ACCME Connectivity to PARS"
                            },
                            {
                              text: "Maintenance of Certification"
                            },
                            {
                              text: "External CME Credit Tracking"
                            },
                            {
                              text: "Financial Statements"
                            },
                            {
                              text: "Event Reporting"
                            },
                            {
                              text: "Speaker Reporting"
                            },
                            {
                              text: "Mobile CME Access"
                            }
                          ];
                        } catch (e) {
                          if (
                            e instanceof TypeError ||
                            e?.plasmicType === "PlasmicUndefinedDataError"
                          ) {
                            return [];
                          }
                          throw e;
                        }
                      })()
                    ).map((__plasmic_item_0, __plasmic_idx_0) => {
                      const currentItem = __plasmic_item_0;
                      const currentIndex = __plasmic_idx_0;
                      return (
                        <ListItem
                          className={classNames(
                            "__wab_instance",
                            sty.listItem__cTnb
                          )}
                          key={currentIndex}
                          text={(() => {
                            try {
                              return currentItem.text;
                            } catch (e) {
                              if (
                                e instanceof TypeError ||
                                e?.plasmicType === "PlasmicUndefinedDataError"
                              ) {
                                return undefined;
                              }
                              throw e;
                            }
                          })()}
                        >
                          <Icon5Icon
                            className={classNames("all", sty.svg__ddtn6)}
                            role={"img"}
                          />
                        </ListItem>
                      );
                    })}
                  </div>
                </div>
              </div>
              <div
                data-plasmic-name={"freeBox"}
                data-plasmic-override={overrides.freeBox}
                className={classNames("all", sty.freeBox)}
              />
            </div>
          </div>
        </div>
      ) : null}
      {(
        hasVariant(globalVariants, "mobile", "mobile")
          ? false
          : hasVariant(globalVariants, "mobile", "tabletPortrait")
            ? true
            : false
      ) ? (
        <div
          data-plasmic-name={"tablet"}
          data-plasmic-override={overrides.tablet}
          className={classNames("all", sty.tablet)}
        >
          <div
            data-plasmic-name={"row6"}
            data-plasmic-override={overrides.row6}
            className={classNames("all", sty.row6)}
          >
            <FeaturesProductHeader
              className={classNames(
                "__wab_instance",
                sty.featuresProductHeader__x8Z7J
              )}
              description={
                hasVariant(globalVariants, "mobile", "mobile")
                  ? "MyEvaluations streamlines medical training with efficient scheduling, compliance tracking, and custom evaluations. The secure platform saves time and resources, enabling comprehensive reports for improved outcomes."
                  : "MyCME streamlines CME fulfillment, automates PARS reports, and maintains financial records. Faculty benefits from a unified system for tracking evaluations and reporting MOC to ACCME-supported boards."
              }
              subtitle={
                hasVariant(globalVariants, "mobile", "mobile")
                  ? "Product"
                  : "Product"
              }
            >
              <Logo
                className={classNames("__wab_instance", sty.logo__yxrkp)}
                product={"myCme"}
              />
            </FeaturesProductHeader>
          </div>
          <div
            data-plasmic-name={"key4"}
            data-plasmic-override={overrides.key4}
            className={classNames("all", sty.key4)}
          >
            <header
              data-plasmic-name={"header4"}
              data-plasmic-override={overrides.header4}
              className={classNames("all", sty.header4)}
            >
              <h2
                className={classNames(
                  "all",
                  "h2",
                  "h2__bvRZj",
                  "__wab_text",
                  sty.h2__sMr9T
                )}
              >
                {"Key Features"}
              </h2>
            </header>
            <div
              data-plasmic-name={"list11"}
              data-plasmic-override={overrides.list11}
              className={classNames("all", sty.list11)}
            >
              <div
                data-plasmic-name={"row7"}
                data-plasmic-override={overrides.row7}
                className={classNames("all", sty.row7)}
              >
                <FeaturesCard
                  className={classNames(
                    "__wab_instance",
                    sty.featuresCard__kRyFu
                  )}
                  desciption={
                    "Incorporate CME management seamlessly. Craft live and enduring activities, streamline scheduling, optimize resource allocation, and centralize recurring events. "
                  }
                  title={"Live & Durable Event Scheduling"}
                >
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img__gm9T)}
                    displayHeight={
                      hasVariant(globalVariants, "mobile", "tabletPortrait")
                        ? "239px"
                        : "239px"
                    }
                    displayMaxHeight={"none"}
                    displayMaxWidth={
                      hasVariant(globalVariants, "mobile", "tabletPortrait")
                        ? "100%"
                        : "100%"
                    }
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={
                      hasVariant(globalVariants, "mobile", "tabletPortrait")
                        ? {
                            src: "https://img.plasmic.app/img-optimizer/v1/img/ffae84bb12c6d9e0bddc6d44c05fcfd4.png",
                            fullWidth: 374,
                            fullHeight: 239
                          }
                        : {
                            src: "https://site-assets.plasmic.app/2b349f46b7ab246ce77422297d6551d7.svg",
                            fullWidth: 374,
                            fullHeight: 239,
                            aspectRatio: 1.564854
                          }
                    }
                  />
                </FeaturesCard>
                <FeaturesCard
                  className={classNames(
                    "__wab_instance",
                    sty.featuresCard__oTfD8
                  )}
                  desciption={
                    "Issue, earn and store CME certificates effortlessly. Design certificate templates for future use. Track external CME credits for comprehensive education management."
                  }
                  title={"CME Certificate Management"}
                >
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img__a2WLz)}
                    displayHeight={"239px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"100%"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={{
                      src: "https://img.plasmic.app/img-optimizer/v1/img/8fabeaac8b8d5113cbb6018ddc2d60ce.png",
                      fullWidth: 374,
                      fullHeight: 239
                    }}
                  />
                </FeaturesCard>
              </div>
              <div
                data-plasmic-name={"row8"}
                data-plasmic-override={overrides.row8}
                className={classNames("all", sty.row8)}
              >
                <FeaturesCard
                  className={classNames(
                    "__wab_instance",
                    sty.featuresCard__iLFoq
                  )}
                  desciption={
                    "Automate CME reporting with direct ACCME PARS integration. Streamline event data linking for timely submissions, maintaining high training standards, reducing administrative burden, and ensuring accreditation compliance."
                  }
                  title={"ACCME Connectivity to PARS"}
                >
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img__wc9Sv)}
                    displayHeight={"239px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={{
                      src: "https://img.plasmic.app/img-optimizer/v1/img/60719a6ed83c2cc70dbca19adf82e2ae.png",
                      fullWidth: 374,
                      fullHeight: 239
                    }}
                  />
                </FeaturesCard>
                <FeaturesCard
                  className={classNames(
                    "__wab_instance",
                    sty.featuresCard__q91K
                  )}
                  desciption={
                    "Implement registration fees, receive automatic reminders, and enable self check-in with QR codes. Streamline fiscal tracking, enhance program reach, and simplify administrative processes."
                  }
                  title={"Event Financial Management"}
                >
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img___5Lo60)}
                    displayHeight={"239px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={{
                      src: "https://site-assets.plasmic.app/02af6c387b8e6a61cfc003728e574b65.svg",
                      fullWidth: 374,
                      fullHeight: 239,
                      aspectRatio: 1.564854
                    }}
                  />
                </FeaturesCard>
              </div>
            </div>
          </div>
          <div
            data-plasmic-name={"all3"}
            data-plasmic-override={overrides.all3}
            className={classNames("all", sty.all3)}
          >
            <h2
              data-plasmic-name={"title3"}
              data-plasmic-override={overrides.title3}
              className={classNames(
                "all",
                "h2",
                "h2__bvRZj",
                "__wab_text",
                sty.title3
              )}
            >
              {"Full Feature List"}
            </h2>
            <div
              data-plasmic-name={"sections4"}
              data-plasmic-override={overrides.sections4}
              className={classNames("all", sty.sections4)}
            >
              <div
                data-plasmic-name={"col4"}
                data-plasmic-override={overrides.col4}
                className={classNames("all", sty.col4)}
              >
                <div
                  data-plasmic-name={"list3"}
                  data-plasmic-override={overrides.list3}
                  className={classNames("all", sty.list3)}
                >
                  {(_par => (!_par ? [] : Array.isArray(_par) ? _par : [_par]))(
                    (() => {
                      try {
                        return [
                          {
                            text: "Event Evaluations"
                          },
                          {
                            text: "Live Event Scheduling"
                          },
                          {
                            text: "Durable Event Library"
                          },
                          {
                            text: "External Registration"
                          },
                          {
                            text: "Fee Processing"
                          },
                          {
                            text: "Membership Management"
                          },
                          {
                            text: "Flier Production"
                          }
                        ];
                      } catch (e) {
                        if (
                          e instanceof TypeError ||
                          e?.plasmicType === "PlasmicUndefinedDataError"
                        ) {
                          return [];
                        }
                        throw e;
                      }
                    })()
                  ).map((__plasmic_item_0, __plasmic_idx_0) => {
                    const currentItem = __plasmic_item_0;
                    const currentIndex = __plasmic_idx_0;
                    return (
                      <ListItem
                        className={classNames(
                          "__wab_instance",
                          sty.listItem___9VHxw
                        )}
                        key={currentIndex}
                        text={(() => {
                          try {
                            return currentItem.text;
                          } catch (e) {
                            if (
                              e instanceof TypeError ||
                              e?.plasmicType === "PlasmicUndefinedDataError"
                            ) {
                              return undefined;
                            }
                            throw e;
                          }
                        })()}
                      >
                        <Icon5Icon
                          className={classNames("all", sty.svg___2Ejme)}
                          role={"img"}
                        />
                      </ListItem>
                    );
                  })}
                </div>
              </div>
              <div
                data-plasmic-name={"col11"}
                data-plasmic-override={overrides.col11}
                className={classNames("all", sty.col11)}
              >
                <div
                  data-plasmic-name={"section7"}
                  data-plasmic-override={overrides.section7}
                  className={classNames("all", sty.section7)}
                >
                  <div
                    data-plasmic-name={"list5"}
                    data-plasmic-override={overrides.list5}
                    className={classNames("all", sty.list5)}
                  >
                    {(_par =>
                      !_par ? [] : Array.isArray(_par) ? _par : [_par])(
                      (() => {
                        try {
                          return [
                            {
                              text: "ACCME Connectivity to PARS"
                            },
                            {
                              text: "Maintenance of Certification"
                            },
                            {
                              text: "External CME Credit Tracking"
                            },
                            {
                              text: "Financial Statements"
                            },
                            {
                              text: "Event Reporting"
                            },
                            {
                              text: "Speaker Reporting"
                            },
                            {
                              text: "Mobile CME Access"
                            }
                          ];
                        } catch (e) {
                          if (
                            e instanceof TypeError ||
                            e?.plasmicType === "PlasmicUndefinedDataError"
                          ) {
                            return [];
                          }
                          throw e;
                        }
                      })()
                    ).map((__plasmic_item_0, __plasmic_idx_0) => {
                      const currentItem = __plasmic_item_0;
                      const currentIndex = __plasmic_idx_0;
                      return (
                        <ListItem
                          className={classNames(
                            "__wab_instance",
                            sty.listItem__aByf3
                          )}
                          key={currentIndex}
                          text={(() => {
                            try {
                              return currentItem.text;
                            } catch (e) {
                              if (
                                e instanceof TypeError ||
                                e?.plasmicType === "PlasmicUndefinedDataError"
                              ) {
                                return undefined;
                              }
                              throw e;
                            }
                          })()}
                        >
                          <Icon5Icon
                            className={classNames("all", sty.svg__sBle)}
                            role={"img"}
                          />
                        </ListItem>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : null}
      {(hasVariant(globalVariants, "mobile", "mobile") ? true : false) ? (
        <div
          data-plasmic-name={"mobile"}
          data-plasmic-override={overrides.mobile}
          className={classNames("all", sty.mobile)}
        >
          <div
            data-plasmic-name={"header3"}
            data-plasmic-override={overrides.header3}
            className={classNames("all", sty.header3)}
          >
            <FeaturesProductHeader
              className={classNames(
                "__wab_instance",
                sty.featuresProductHeader__ehMFb
              )}
              description={
                hasVariant(globalVariants, "mobile", "mobile")
                  ? "MyCME streamlines CME fulfillment, automates PARS reports, and maintains financial records. Faculty benefits from a unified system for tracking evaluations and reporting MOC to ACCME-supported boards."
                  : undefined
              }
              subtitle={
                hasVariant(globalVariants, "mobile", "mobile")
                  ? "Product"
                  : undefined
              }
            >
              <Logo
                className={classNames("__wab_instance", sty.logo__odhtj)}
                product={"myCme"}
              />
            </FeaturesProductHeader>
          </div>
          <div
            data-plasmic-name={"key3"}
            data-plasmic-override={overrides.key3}
            className={classNames("all", sty.key3)}
          >
            <header
              data-plasmic-name={"header2"}
              data-plasmic-override={overrides.header2}
              className={classNames("all", sty.header2)}
            >
              <h2
                className={classNames(
                  "all",
                  "h2",
                  "h2__bvRZj",
                  "__wab_text",
                  sty.h2__nqFlM
                )}
              >
                {"Key Features"}
              </h2>
            </header>
            <div
              data-plasmic-name={"list6"}
              data-plasmic-override={overrides.list6}
              className={classNames("all", sty.list6)}
            >
              <FeaturesCard
                className={classNames("__wab_instance", sty.featuresCard__uNYO)}
                desciption={
                  "Incorporate CME management seamlessly. Craft live and enduring activities, streamline scheduling, optimize resource allocation, and centralize recurring events. "
                }
                title={"Live & Durable Event Scheduling"}
              >
                <PlasmicImg__
                  alt={""}
                  className={classNames(sty.img__g2Tqp)}
                  displayHeight={"auto"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"auto"}
                  loader={"plasmic"}
                  loading={"lazy"}
                  src={{
                    src: "https://img.plasmic.app/img-optimizer/v1/img/ffae84bb12c6d9e0bddc6d44c05fcfd4.png",
                    fullWidth: 374,
                    fullHeight: 239
                  }}
                />
              </FeaturesCard>
              <FeaturesCard
                className={classNames(
                  "__wab_instance",
                  sty.featuresCard__wrdlL
                )}
                desciption={
                  "Issue, earn and store CME certificates effortlessly. Design certificate templates for future use. Track external CME credits for comprehensive education management."
                }
                title={"CME Certificate Management"}
              >
                <PlasmicImg__
                  alt={""}
                  className={classNames(sty.img__lkexR)}
                  displayHeight={"auto"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"auto"}
                  loader={"plasmic"}
                  loading={"lazy"}
                  src={{
                    src: "https://img.plasmic.app/img-optimizer/v1/img/8fabeaac8b8d5113cbb6018ddc2d60ce.png",
                    fullWidth: 374,
                    fullHeight: 239
                  }}
                />
              </FeaturesCard>
              <FeaturesCard
                className={classNames(
                  "__wab_instance",
                  sty.featuresCard__zkku5
                )}
                desciption={
                  "Automate CME reporting with direct ACCME PARS integration. Streamline event data linking for timely submissions, maintaining high training standards, reducing administrative burden, and ensuring accreditation compliance."
                }
                title={"ACCME Connectivity to PARS"}
              >
                <PlasmicImg__
                  alt={""}
                  className={classNames(sty.img__zaPcr)}
                  displayHeight={"auto"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"auto"}
                  loader={"plasmic"}
                  loading={"lazy"}
                  src={{
                    src: "https://img.plasmic.app/img-optimizer/v1/img/60719a6ed83c2cc70dbca19adf82e2ae.png",
                    fullWidth: 374,
                    fullHeight: 239
                  }}
                />
              </FeaturesCard>
              <FeaturesCard
                className={classNames(
                  "__wab_instance",
                  sty.featuresCard___1Lfov
                )}
                desciption={
                  "Implement registration fees, receive automatic reminders, and enable self check-in with QR codes. Streamline fiscal tracking, enhance program reach, and simplify administrative processes."
                }
                title={"Event Financial Management"}
              >
                <PlasmicImg__
                  alt={""}
                  className={classNames(sty.img__psg6X)}
                  displayHeight={"auto"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"auto"}
                  loader={"plasmic"}
                  loading={"lazy"}
                  src={{
                    src: "https://site-assets.plasmic.app/02af6c387b8e6a61cfc003728e574b65.svg",
                    fullWidth: 374,
                    fullHeight: 239,
                    aspectRatio: 1.564854
                  }}
                />
              </FeaturesCard>
            </div>
          </div>
          <div
            data-plasmic-name={"all2"}
            data-plasmic-override={overrides.all2}
            className={classNames("all", sty.all2)}
          >
            <h2
              data-plasmic-name={"title2"}
              data-plasmic-override={overrides.title2}
              className={classNames(
                "all",
                "h2",
                "h2__bvRZj",
                "__wab_text",
                sty.title2
              )}
            >
              {"Full Feature List"}
            </h2>
            <div
              data-plasmic-name={"sections5"}
              data-plasmic-override={overrides.sections5}
              className={classNames("all", sty.sections5)}
            >
              <div
                data-plasmic-name={"col8"}
                data-plasmic-override={overrides.col8}
                className={classNames("all", sty.col8)}
              >
                <div
                  data-plasmic-name={"list12"}
                  data-plasmic-override={overrides.list12}
                  className={classNames("all", sty.list12)}
                >
                  {(_par => (!_par ? [] : Array.isArray(_par) ? _par : [_par]))(
                    (() => {
                      try {
                        return [
                          {
                            text: "Event Evaluations"
                          },
                          {
                            text: "Live Event Scheduling"
                          },
                          {
                            text: "Durable Event Library"
                          },
                          {
                            text: "External Registration"
                          },
                          {
                            text: "Fee Processing"
                          },
                          {
                            text: "Membership Management"
                          },
                          {
                            text: "Flier Production"
                          }
                        ];
                      } catch (e) {
                        if (
                          e instanceof TypeError ||
                          e?.plasmicType === "PlasmicUndefinedDataError"
                        ) {
                          return [];
                        }
                        throw e;
                      }
                    })()
                  ).map((__plasmic_item_0, __plasmic_idx_0) => {
                    const currentItem = __plasmic_item_0;
                    const currentIndex = __plasmic_idx_0;
                    return (
                      <ListItem
                        className={classNames(
                          "__wab_instance",
                          sty.listItem__hoXv8
                        )}
                        key={currentIndex}
                        text={(() => {
                          try {
                            return currentItem.text;
                          } catch (e) {
                            if (
                              e instanceof TypeError ||
                              e?.plasmicType === "PlasmicUndefinedDataError"
                            ) {
                              return undefined;
                            }
                            throw e;
                          }
                        })()}
                      >
                        <Icon5Icon
                          className={classNames("all", sty.svg___2VmpS)}
                          role={"img"}
                        />
                      </ListItem>
                    );
                  })}
                </div>
              </div>
              <div
                data-plasmic-name={"col12"}
                data-plasmic-override={overrides.col12}
                className={classNames("all", sty.col12)}
              >
                <div
                  data-plasmic-name={"section8"}
                  data-plasmic-override={overrides.section8}
                  className={classNames("all", sty.section8)}
                >
                  <div
                    data-plasmic-name={"list13"}
                    data-plasmic-override={overrides.list13}
                    className={classNames("all", sty.list13)}
                  >
                    {(_par =>
                      !_par ? [] : Array.isArray(_par) ? _par : [_par])(
                      (() => {
                        try {
                          return [
                            {
                              text: "ACCME Connectivity to PARS"
                            },
                            {
                              text: "Maintenance of Certification"
                            },
                            {
                              text: "External CME Credit Tracking"
                            },
                            {
                              text: "Financial Statements"
                            },
                            {
                              text: "Event Reporting"
                            },
                            {
                              text: "Speaker Reporting"
                            },
                            {
                              text: "Mobile CME Access"
                            }
                          ];
                        } catch (e) {
                          if (
                            e instanceof TypeError ||
                            e?.plasmicType === "PlasmicUndefinedDataError"
                          ) {
                            return [];
                          }
                          throw e;
                        }
                      })()
                    ).map((__plasmic_item_0, __plasmic_idx_0) => {
                      const currentItem = __plasmic_item_0;
                      const currentIndex = __plasmic_idx_0;
                      return (
                        <ListItem
                          className={classNames(
                            "__wab_instance",
                            sty.listItem___89Uvc
                          )}
                          key={currentIndex}
                          text={(() => {
                            try {
                              return currentItem.text;
                            } catch (e) {
                              if (
                                e instanceof TypeError ||
                                e?.plasmicType === "PlasmicUndefinedDataError"
                              ) {
                                return undefined;
                              }
                              throw e;
                            }
                          })()}
                        >
                          <Icon5Icon
                            className={classNames("all", sty.svg__uzeLw)}
                            role={"img"}
                          />
                        </ListItem>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </section>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  myCme: [
    "myCme",
    "desktop",
    "row",
    "key2",
    "header",
    "list",
    "row2",
    "all",
    "title",
    "sections",
    "col2",
    "list2",
    "col3",
    "section2",
    "list4",
    "freeBox",
    "tablet",
    "row6",
    "key4",
    "header4",
    "list11",
    "row7",
    "row8",
    "all3",
    "title3",
    "sections4",
    "col4",
    "list3",
    "col11",
    "section7",
    "list5",
    "mobile",
    "header3",
    "key3",
    "header2",
    "list6",
    "all2",
    "title2",
    "sections5",
    "col8",
    "list12",
    "col12",
    "section8",
    "list13"
  ],
  desktop: [
    "desktop",
    "row",
    "key2",
    "header",
    "list",
    "row2",
    "all",
    "title",
    "sections",
    "col2",
    "list2",
    "col3",
    "section2",
    "list4",
    "freeBox"
  ],
  row: ["row"],
  key2: ["key2", "header", "list", "row2"],
  header: ["header"],
  list: ["list", "row2"],
  row2: ["row2"],
  all: [
    "all",
    "title",
    "sections",
    "col2",
    "list2",
    "col3",
    "section2",
    "list4",
    "freeBox"
  ],
  title: ["title"],
  sections: [
    "sections",
    "col2",
    "list2",
    "col3",
    "section2",
    "list4",
    "freeBox"
  ],
  col2: ["col2", "list2"],
  list2: ["list2"],
  col3: ["col3", "section2", "list4"],
  section2: ["section2", "list4"],
  list4: ["list4"],
  freeBox: ["freeBox"],
  tablet: [
    "tablet",
    "row6",
    "key4",
    "header4",
    "list11",
    "row7",
    "row8",
    "all3",
    "title3",
    "sections4",
    "col4",
    "list3",
    "col11",
    "section7",
    "list5"
  ],
  row6: ["row6"],
  key4: ["key4", "header4", "list11", "row7", "row8"],
  header4: ["header4"],
  list11: ["list11", "row7", "row8"],
  row7: ["row7"],
  row8: ["row8"],
  all3: [
    "all3",
    "title3",
    "sections4",
    "col4",
    "list3",
    "col11",
    "section7",
    "list5"
  ],
  title3: ["title3"],
  sections4: ["sections4", "col4", "list3", "col11", "section7", "list5"],
  col4: ["col4", "list3"],
  list3: ["list3"],
  col11: ["col11", "section7", "list5"],
  section7: ["section7", "list5"],
  list5: ["list5"],
  mobile: [
    "mobile",
    "header3",
    "key3",
    "header2",
    "list6",
    "all2",
    "title2",
    "sections5",
    "col8",
    "list12",
    "col12",
    "section8",
    "list13"
  ],
  header3: ["header3"],
  key3: ["key3", "header2", "list6"],
  header2: ["header2"],
  list6: ["list6"],
  all2: [
    "all2",
    "title2",
    "sections5",
    "col8",
    "list12",
    "col12",
    "section8",
    "list13"
  ],
  title2: ["title2"],
  sections5: ["sections5", "col8", "list12", "col12", "section8", "list13"],
  col8: ["col8", "list12"],
  list12: ["list12"],
  col12: ["col12", "section8", "list13"],
  section8: ["section8", "list13"],
  list13: ["list13"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  myCme: "section";
  desktop: "div";
  row: "div";
  key2: "div";
  header: "header";
  list: "div";
  row2: "div";
  all: "div";
  title: "h2";
  sections: "div";
  col2: "div";
  list2: "div";
  col3: "div";
  section2: "div";
  list4: "div";
  freeBox: "div";
  tablet: "div";
  row6: "div";
  key4: "div";
  header4: "header";
  list11: "div";
  row7: "div";
  row8: "div";
  all3: "div";
  title3: "h2";
  sections4: "div";
  col4: "div";
  list3: "div";
  col11: "div";
  section7: "div";
  list5: "div";
  mobile: "div";
  header3: "div";
  key3: "div";
  header2: "header";
  list6: "div";
  all2: "div";
  title2: "h2";
  sections5: "div";
  col8: "div";
  list12: "div";
  col12: "div";
  section8: "div";
  list13: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicFeaturesMyCme__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicFeaturesMyCme__VariantsArgs;
    args?: PlasmicFeaturesMyCme__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicFeaturesMyCme__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicFeaturesMyCme__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicFeaturesMyCme__ArgProps,
          internalVariantPropNames: PlasmicFeaturesMyCme__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicFeaturesMyCme__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "myCme") {
    func.displayName = "PlasmicFeaturesMyCme";
  } else {
    func.displayName = `PlasmicFeaturesMyCme.${nodeName}`;
  }
  return func;
}

export const PlasmicFeaturesMyCme = Object.assign(
  // Top-level PlasmicFeaturesMyCme renders the root element
  makeNodeComponent("myCme"),
  {
    // Helper components rendering sub-elements
    desktop: makeNodeComponent("desktop"),
    row: makeNodeComponent("row"),
    key2: makeNodeComponent("key2"),
    header: makeNodeComponent("header"),
    list: makeNodeComponent("list"),
    row2: makeNodeComponent("row2"),
    all: makeNodeComponent("all"),
    title: makeNodeComponent("title"),
    sections: makeNodeComponent("sections"),
    col2: makeNodeComponent("col2"),
    list2: makeNodeComponent("list2"),
    col3: makeNodeComponent("col3"),
    section2: makeNodeComponent("section2"),
    list4: makeNodeComponent("list4"),
    freeBox: makeNodeComponent("freeBox"),
    tablet: makeNodeComponent("tablet"),
    row6: makeNodeComponent("row6"),
    key4: makeNodeComponent("key4"),
    header4: makeNodeComponent("header4"),
    list11: makeNodeComponent("list11"),
    row7: makeNodeComponent("row7"),
    row8: makeNodeComponent("row8"),
    all3: makeNodeComponent("all3"),
    title3: makeNodeComponent("title3"),
    sections4: makeNodeComponent("sections4"),
    col4: makeNodeComponent("col4"),
    list3: makeNodeComponent("list3"),
    col11: makeNodeComponent("col11"),
    section7: makeNodeComponent("section7"),
    list5: makeNodeComponent("list5"),
    mobile: makeNodeComponent("mobile"),
    header3: makeNodeComponent("header3"),
    key3: makeNodeComponent("key3"),
    header2: makeNodeComponent("header2"),
    list6: makeNodeComponent("list6"),
    all2: makeNodeComponent("all2"),
    title2: makeNodeComponent("title2"),
    sections5: makeNodeComponent("sections5"),
    col8: makeNodeComponent("col8"),
    list12: makeNodeComponent("list12"),
    col12: makeNodeComponent("col12"),
    section8: makeNodeComponent("section8"),
    list13: makeNodeComponent("list13"),

    // Metadata about props expected for PlasmicFeaturesMyCme
    internalVariantProps: PlasmicFeaturesMyCme__VariantProps,
    internalArgProps: PlasmicFeaturesMyCme__ArgProps
  }
);

export default PlasmicFeaturesMyCme;
/* prettier-ignore-end */
